import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from '@vds/grids';

const NotificationWrapper = ({ children }) => {
  const isMobile = window?.screen?.availWidth < 769;

  return (
    <>
      {isMobile && <div>{children}</div>}

      {!isMobile && (
        <Grid>
          <Row bleed="full">
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>{children}</Col>
          </Row>
        </Grid>
      )}
    </>
  );
};

NotificationWrapper.propTypes = {
  children: PropTypes.node,
};

export default NotificationWrapper;
